import { useNavigate, useParams } from 'react-router-dom'

import { Box, Button, Text } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import { useDeleteTrainingClasses } from 'modules/trainings/hooks/TrainingClasses/useDeleteTrainingClasses'

interface Props {
  back: string
}
const DeleteClass = ({ back }: Props) => {
  const { id, classId } = useParams()
  const { delete: deleteTrainingClass, loading } = useDeleteTrainingClasses()
  const { navigation } = useNavigation()
  const navigate = useNavigate()

  const cancel = () => {
    navigate(back)
  }

  const onSubmit = async () => {
    const response = await deleteTrainingClass({ id: Number(classId) })
    const handled = handleResult(response, () => {
      app.setFlash({
        type: 'wrong',
        message: i18n.t('trainings.trainings_revamp.classes.delete_class_modal.error_delete'),
      })
    })

    if (handled.success) {
      app.setFlash({
        type: 'correct',
        message: i18n.t('trainings.trainings_revamp.classes.delete_class_modal.success_delete'),
      })
      navigate(
        navigation.trainings.list.details_revamp.view.trainingClasses.tab.fullPath({
          id: Number(id),
        })
      )
    }
  }

  return (
    <Modal
      title={i18n.t('trainings.trainings_revamp.classes.delete_class_modal.title')}
      onSubmit={onSubmit}
      onClose={() => cancel()}
      illustration="delete"
      description={
        <Box gap={'s16'}>
          {i18n.t('trainings.trainings_revamp.classes.delete_class_modal.description')}
          <Box background="viridian100" padding={'s20'} borderRadius={{ all: 'abs008' }}>
            <Text.Normal size="300" color="grey800" weight="medium">
              {i18n.t('trainings.trainings_revamp.classes.delete_class_modal.alert')}
            </Text.Normal>
          </Box>
        </Box>
      }
      footer={
        <>
          <Button type="secondary" onClick={cancel}>
            {i18n.t('trainings.trainings_revamp.classes.delete_class_modal.cancel')}
          </Button>
          <Button type="negative" submit loading={loading}>
            {i18n.t('trainings.trainings_revamp.classes.delete_class_modal.submit')}
          </Button>
        </>
      }
    ></Modal>
  )
}

export default DeleteClass
